import {BrandCode} from '../../../../brand/types'
import {getDomainName} from '../../../../utils/url'
import {
  cookieSecuritySettings,
  getCookie,
  removeCookie,
  setCookie
} from '../../../utils/cookies'

const BRAND_OVERRIDE_COOKIE = 'brandOverride'
const THEME_OVERRIDE_COOKIE = 'themeOverride'
const SUB_BRAND_COOKIE = 'subBrand'

const makeCookieConfiguration = () => ({
  domain: getDomainName(window.location.hostname),
  expires: 1, // 1 day
  ...cookieSecuritySettings(true)
})

/**
 * Set brandOverride value to cookie
 * @param brandCode - BrandCode
 */
export const persistBrandOverrideOnCookie = (brandCode: BrandCode) => {
  if (!brandCode) return

  const cookieConfiguration = makeCookieConfiguration()
  setCookie(BRAND_OVERRIDE_COOKIE, brandCode, cookieConfiguration)
}

/**
 * Get the brandOverride value from cookie
 */
export const getBrandOverrideFromCookie = (): BrandCode =>
  getCookie(BRAND_OVERRIDE_COOKIE) as BrandCode

/**
 * Remove brandOverride cookie
 */
export const removeBrandOverrideFromCookie = () => {
  const cookieConfiguration = makeCookieConfiguration()
  removeCookie(BRAND_OVERRIDE_COOKIE, cookieConfiguration)
}

/**
 * Set themeOverride value to cookie
 * @param themeOverride - it is used to determine the name of CSS theme file
 */
export const persistThemeOverrideOnCookie = (themeOverride: string): void => {
  if (!themeOverride) return
  setCookie(THEME_OVERRIDE_COOKIE, themeOverride, cookieSecuritySettings(true))
}

/**
 * Get the brandOverride value from cookie
 */
export const getThemeOverrideFromCookie = () => getCookie(THEME_OVERRIDE_COOKIE)

/**
 * Persist subBrand value into cookie
 * @param subBrand - subBrand identifier from URL parameter
 */
export const persistSubBrandOnCookie = (subBrand: string): void => {
  if (!subBrand) return
  const cookieConfiguration = makeCookieConfiguration()
  setCookie(SUB_BRAND_COOKIE, subBrand, cookieConfiguration)
}

/**
 * Get the subBrand value from cookie
 */
export const getSubBrandFromCookie = (): string | undefined =>
  (getCookie(SUB_BRAND_COOKIE) as string) || undefined
